module.exports = __webpack_public_path__ + "img/arrow_carousel.9a152bdf.svg";